export default __webpack_public_path__ + "static/media/games.e1be6da7.webp";